import { render, staticRenderFns } from "./addDocuments.vue?vue&type=template&id=8f514c2a&scoped=true"
import script from "./addDocuments.vue?vue&type=script&lang=js"
export * from "./addDocuments.vue?vue&type=script&lang=js"
import style0 from "./addDocuments.vue?vue&type=style&index=0&id=8f514c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f514c2a",
  null
  
)

export default component.exports